module.exports = __webpack_public_path__ + "static/media/game-forewordbutton.eb3d6245.png";